export default {
  navbar: {
    experience: 'EXPERIENCE',
    skills: 'SKILLS',
    linkstoprojects: 'PROJECTS',
    contact: 'CONTACT',
  },
  about: {
    title: 'I’M MANUEL GOSENDE',
    subtitle: 'FRONTEND DEVELOPER & GRAPHIC DESIGNER',
    description1: "I'm based in Mar del Plata, Argentina, passionate about using technology to create software that combines functionality and UX/UI to improve everyday life and transform the way people interact with the virtual world.",
    description2: "I have a solid knowledge of HTML, CSS, JavaScript, TypeScript and React. Looking at design, I can transform it into responsive web pages with meticulous attention to detail. I am always eager to stay up-to-date with the latest web development tools and technologies.",
    description3: 'Currently, I am exploring React Native to apply my skills to app development.',
  },
  experience: {
    title: '01 EXPERIENCE',
    job1: {
      company: 'AIOTEK',
      time: 'SEPTEMBER 2023 - PRESENT',
      position: 'FRONTEND DEVELOPER',
      description: 'I work as a Frontend Developer on a company-owned product. The technologies I use are React, Typescript, Next, and Tailwind for styling the system.<br /><br />I work alongside a self-managed team composed of developers, architects, and designers. I have created reusable components, custom hooks, and optimized variable contexts for each functionality.',
    },
    job2: {
      company: 'QWAVEE',
      time: 'JANUARY 2022 - AUGUST 2023',
      position: 'FRONTEND DEVELOPER',
      description: 'I worked as a Frontend Developer using React, TypeScript, JavaScript, HTML, Material UI and SCSS as my technological stack, in order to implement functionality and styling to different components. I have worked with REST APIs to retrieve data and render it on the frontend. I have also worked with Web Services to send data to a payment gateway, and integrated Mailchimp for newsletters and form submissions. Additionally, I have experience with Object-Oriented Programming (OOP).<br /><br />I use Git to manage version control for each project, working with branches and different environments for pull request management. I have also used the SSH protocol with a Client-Server architecture to deploy the website in production.<br /><br />Working with Agile methodologies, I am in constant communication with the team to achieve incremental development. Additionally, I provide demos to the client after each sprint to showcase the progress.',
    },
    job3: {
      company: 'PLOOT DISEÑOS',
      time: 'OCTOBER 2016 - NOVEMBER 2021',
      position: 'GRAPHIC DESIGNER',
      description: 'During the years I worked at Ploot Desiños, I was able to grow as a professional and acquire soft skills such as communication with clients and interpreting their ideas. I was responsible for tasks in the Design department, such as creating corporate identities, brands, flyers, logos, among others. I also participated in the production and development of projects in the graphic workshop, such as assembling signage, plotters, and dimensional lettering.',
    },
  },
  skills: {
    title: '02 SKILLS',
    programmer: 'AS PROGRAMMER',
    designer: 'AS DESIGNER',
  },
  linkstoprojects: {
    title: '03 PROJECTS',
    description: 'Here are some of the projects I have worked on during my professional career. I invite you to navigate the links to see the final results.',
    project1: 'PROJECTS',
    project2: 'LANIN | WEB DESIGN',
    project3: 'ILLUSTRATION',
    description2: 'This website was designed and developed by me using some of the tools mentioned above. Below you will find the links to view the Figma mockup and the code on GitHub.',
    project8: 'FIGMA',
    project9: 'GITHUB',
  },
  projects: {
    viramundo: {
      shortDescription: "Visual identity and institutional website design for a travel agency.",
      description: "Comprehensive brand development and institutional website design. The project focused its communication on experiential and exploratory tourism, connecting with a young audience through dynamic graphics and a functional site."
    },
    full_fisio: {
      shortDescription: "Branding and visual identity for a physical therapy team in Tandil.",
      description: "Complete brand identity design for a physical therapy team. The graphic concept communicates active rehabilitation, prevention, and overall well-being, conveying a professional approach to physical health care."
    },
    el_codigo_del_placer: {
      shortDescription: "Brand design focused on authenticity, freedom, and female empowerment.",
      description: "Visual identity creation for a space dedicated to expression and self-knowledge. The graphics reflect femininity, freedom, and independence, steering away from traditional stereotypes through a modern and authentic aesthetic."
    },
    arias_arguelles: {
      shortDescription: "Graphic identity for an agricultural tech and drone spraying company.",
      description: "Brand development and social media management for drone-based agricultural services. The identity features strong typography and dynamic elements that convey precision, innovation, and constant support for farmers."
    },
    bueno_lagarto: {
      shortDescription: "Apparel brand inspired by nature, travel, and outdoor lifestyle.",
      description: "Personal project and clothing brand centered around an adventurous lifestyle, friendship, and connection with nature. Comprehensive execution from product management to graphic and visual design."
    },
    krenergy: {
      shortDescription: "Brand design focused on renewable energy solutions and sustainability.",
      description: "Logo design and visual identity for a clean energy brand. The design uses geometric shapes and a color palette that communicates innovation, sustainability, and energy efficiency."
    },
    lupino: {
      shortDescription: "Vintage-styled logo design for a record label and music distributor.",
      description: "Brand development with a retro and vintage-inspired aesthetic for a project focused on vinyl records and analog music, combining nostalgia and character in its branding."
    },
    idear: {
      shortDescription: "Brand identity for a digital marketing and communication agency.",
      description: "Logo and corporate identity design merging concepts of technology, strategic marketing, and visual design, achieving a modern, versatile image tailored for digital environments."
    },
  },
  contact: {
    title: 'CONTACT',
    description: 'Thank you very much for visiting my portfolio!<br />You can reach out to me ',
    link: 'here.',
    copyright: '@DESIGN & @PROGRAMMING',
    name: 'MANUEL GOSENDE',
  },
};
